import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOriginComponent } from './simple-icons-origin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOriginComponent ],
    exports:      [ SimpleIconsOriginComponent ],
    bootstrap:    []
})
export class SimpleIconsOriginModule {}
